<script>
import Roles from '@/mixins/Roles'
import Filters from '@/mixins/Filters'
import { mapGetters } from 'vuex'
export default {
    name: 'CompanyFilters',

    mixins: [Roles, Filters],

    data() {
        return {
            model: {
                name: null,
                user_id: null,
                as_provider: null,
                as_customer: null,
            },
        }
    },

    computed: mapGetters(['services']),
}
</script>

<template lang="pug">
div.overflow-scroll
    acrm-input-line.mb-1(
        dark-label v-model="model.name") {{ $t('COMPANIES.NAME') }}
    acrm-multi-select.mb-0(
        :value="model.as_customer"
        @input="model.as_customer = $event.id"
        :options="services"
        track-by="id"
        option-label="translated"
        dark-label
    ) {{ $t('COMPANIES.CLIENT') }}
    acrm-multi-select.mb-0(
        :value="model.as_provider"
        @input="model.as_provider = $event.id"
        :options="services"
        track-by="id"
        option-label="translated"
        dark-label
    ) {{ $t('COMPANIES.PROVIDER') }}
    acrm-input-user-select.mb-1(
        dark-label v-model="model.user_id") {{ $t('USERS.USER') }}
    .separator-top.pt-3.mt-5
    .row.mb-3
        .col-24.col-md-12
            acrm-input-button(block @click="filter").mb-2.mb-md-0 {{ $t('FILTER.FILTER') }}
        .col-24.col-md-12
            acrm-input-button(variant="link" block @click="clear") {{ $t('FILTER.DELETE_FILTER') }}
</template>
